// @flow
import React from 'react';

type FuelDataItem = {
  gal: string,
  kg: string,
  lbs: string,
  liter: string,
  title: string,
  percent: string,
  cg?: string,
};

type FuelDataType = {
  landing: FuelDataItem,
  max: FuelDataItem,
  min: FuelDataItem,
  takeoff: FuelDataItem,
};

type Props = {
  data: FuelDataType,
  onCopy: () => {}
}

const copyKeys =  ["min", "max", "reserve"];

export default class WeightAndBalanceFuel extends React.Component<Props> {

  onClick(e: Event, name: string) {
    e.preventDefault();
    const {onCopy} = this.props;

    if (onCopy) {
      onCopy(name);
    }
  }

  render() {
    const {data} = this.props;
    return (
      <div>
        <table className='width-100 passengers-table width-100'>
          <thead className='passengers-table-header'>
          <tr>
            <th style={{width: "40%"}}></th>
            <th>
              <span>Time</span>
            </th>
            <th>
              <span>%</span>
            </th>
            <th>
              <span>Lbs</span>
            </th>
            <th>
              <span>Gal</span>
            </th>
          </tr>
          </thead>
          <tbody>
          {Object.keys(data).map((key: string, index: number) => {
            const row = data[key];
            const {
              title = "-",
              time = 0,
              percent = "0.00",
              lbs = "0.00",
              gal = "0.00"
            } = row;

            return (
              <tr key={`${title}-${index}`}>
                <td className={"relative"}>
                  {(copyKeys.includes(key)) &&
                    (<a
                      onClick={(e) => {this.onClick(e, key)}}
                      className="weight-balance-copy-icon"
                      alt={"Copy"}
                    >
                      <i className="icon list-activity"></i>
                    </a>)
                  }
                  {title}
                </td>
                <td>{parseFloat(time).toFixed(2)}</td>
                <td>{parseFloat(percent).toFixed(2)}</td>
                <td>{parseFloat(lbs).toFixed(2)}</td>
                <td>{parseFloat(gal).toFixed(2)}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    )
  }
}
